import React, { useState } from 'react';
import { TopBarMenuButtonStateContext } from './top-bar-menu-button-state-context';

export function TopBarMenuButtonStateProvider({ isOpen = false, children }) {
  const [open, setOpen] = useState(isOpen);

  const toggle = () => {
    setOpen(!open);
  };

  return (
    <TopBarMenuButtonStateContext.Provider
      value={{
        open,
        toggle,
      }}
    >
      {children}
    </TopBarMenuButtonStateContext.Provider>
  );
}
